<template>
    <section>
        <SurveyTestCompletion 
            :for_personnel="true"
        />
    </section>
</template>
  
<script>

import SurveyTestCompletion from '../SurveyTestCompletion/SurveyTestCompletion'

export default {

    name: 'SurveyTestCompletionPersonnel',

    components: {
        SurveyTestCompletion,
    },

    data() {
        return {
        }
    },

    methods:
    {
        
    },

   
}

</script>